export default __webpack_public_path__ + "static/media/5.6921f999.jpg";